"use client";

import { LISTING_API } from "@/lib/constants";
import FamilyCard from "@/modules/categories-listings/components/categories-listing-card";
import { TListingData } from "@/services/categories-listing";
import { useQuery } from "@tanstack/react-query";
import Skeleton from "react-loading-skeleton";

async function getListingData() {
	const url = new URL(`${LISTING_API}`);
	const res = await fetch(url);

	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}

	const { data } = (await res.json()) as { data: TListingData[] };

	return data;
}

const Listings = () => {
	const {
		isLoading,
		isError,
		data: listings = [],
	} = useQuery({ queryKey: ["listings"], queryFn: getListingData });

	if (isError) {
		return <span>Something went wrong while fetching families</span>;
	}

	return isLoading ? (
		<div className="flex flex-col gap-8">
			<Skeleton count={1} height={256} className="flex-1" />
			<Skeleton count={1} height={256} className="flex-1" />
			<Skeleton count={1} height={256} className="flex-1" />
		</div>
	) : (
		<div className="flex flex-wrap gap-6">
			{listings?.map((listing: TListingData) => (
				<FamilyCard
					key={listing.id}
					name={listing.title}
					icon={listing.logoUrl}
					description={listing.description}
					slug={listing.slug || ""}
					numberOfProducts={listing.productsCount}
					leaders={listing.leaders}
					ambassadors={listing.ambassadors}
					productLogos={listing.productLogos || []}
				/>
			))}
		</div>
	);
};

export default Listings;
